import { Link as RouterLink } from 'react-router-dom';

import { useView } from '@/hooks';
import { Icon, Link } from '@/ui';

import Header from './Header';
import Summary from './Summary';
import Survey from './Survey';

const Insights = () => {
  const { isClient } = useView();

  if (isClient) {
    return (
      <div className="mx-auto flex w-full max-w-[1020px] flex-col p-4">
        <Link
          className="flex no-underline"
          color="text.primary"
          component={RouterLink}
          to="/m/insights"
        >
          <Icon>chevron_left</Icon>Insights
        </Link>
        <Survey />
      </div>
    );
  }

  return (
    <div className="m-6 flex flex-col lg:mx-auto lg:w-280 ">
      <Header />
      <Summary />
    </div>
  );
};

export default Insights;
